import { Divider } from '@patternfly/react-core'
import * as React from 'react'
import { useCallback } from 'react'

import type {
  IProgram,
  IProgramInteraction,
  IProgramInteractionId} from '@app/domain/program/program.interface';
import {
  IInteractionStatusId,
  ProgramInteractionTypeId,
  selectInteractionInstrumentsModalTittle,
} from '@app/domain/program/program.interface'

import { AdHocInteraction } from './ad-hoc-interaction'
import { InteractionSection } from './interaction-section'

interface Props {
  onDeleteInteraction: (programIteractionId: IProgramInteractionId) => void
  onEditInteraction: (
    modalTittle: string,
    programInteractionTypeId: ProgramInteractionTypeId,
    programInteraction?: IProgramInteraction,
  ) => void
  onEditInteractionLabel: (interactionId: string, label: string) => void
  program: IProgram
}

export const AdHocInteractionSection = ({
  onDeleteInteraction,
  onEditInteraction,
  onEditInteractionLabel,
  program,
}: Props) => {
  const handleAddInteraction = useCallback(() => {
    return (event) => {
      event.preventDefault()
      onEditInteraction(
        selectInteractionInstrumentsModalTittle,
        ProgramInteractionTypeId.AdHocInteraction,
      )
    }
  }, [onEditInteraction])

  const renderInteractions = (programInteractions: IProgramInteraction[]) => {
    if (!programInteractions || programInteractions.length === 0) {
      return null
    }

    const activeInteractions = programInteractions.filter(
      (interaction) => interaction.status !== IInteractionStatusId.Removed,
    )

    if (activeInteractions.length === 0) {
      return null
    }

    return (
      <>
        {activeInteractions.map((programInteraction) => (
          <AdHocInteraction
            key={programInteraction.id}
            onDeleteInteraction={onDeleteInteraction}
            onEditInteraction={onEditInteraction}
            onEditInteractionLabel={onEditInteractionLabel}
            programInteraction={programInteraction}
          />
        ))}
      </>
    )
  }

  return (
    <InteractionSection
      toolTip="Unscheduled interactions to collect follow-up information on a patient in a program."
      subtitle="Ad Hoc Follow-ups"
      addInteraction={handleAddInteraction()}
    >
      <Divider />
      {renderInteractions(
        program?.interactions[ProgramInteractionTypeId.AdHocInteraction],
      )}
    </InteractionSection>
  )
}
